import { EllipsisText } from '@components/EllipsisText';

import { withCellValue } from '../withCellValue';

const CellWithEllipsis = withCellValue(EllipsisText);

export { CellWithEllipsis };
